/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";

const HowItsComponent = () => {
  return (
    <>
      <>
        <div className="inner-page-banner">
          <div className="breadcrumb-vec-btm">
            <img
              className="img-fluid"
              src="assets/images/bg/inner-banner-btm-vec.png"
              alt=""
            />
          </div>
          <div className="container">
            <div className="row justify-content-center align-items-center text-center">
              <div className="col-lg-6 align-items-center">
                <div className="banner-content">
                  <h1>How Its Works</h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        How Its Works
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="banner-img d-lg-block d-none">
                  <div className="banner-img-bg">
                    <img
                      className="img-fluid"
                      src="assets/images/bg/inner-banner-vec.png"
                      alt=""
                    />
                  </div>
                  <img
                    className="img-fluid"
                    src="assets/images/bg/inner-banner-img.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="h1-story-area two mb-120 pt-120">
          <div className="container">
            <div className="row g-lg-4 gy-5">
              <div className="col-lg-6">
                <div className="section-title1">
                  <span>
                    <img src="assets/images/icon/section-vec-l1.svg" alt="" />
                    How Its Works
                    <img src="assets/images/icon/section-vec-r1.svg" alt="" />
                  </span>
                  <h2>How Its Works</h2>
                </div>
                <div className="story-content">
                  <p>
                    Step 1 is to register your pet with Pet Avenger. Your pet
                    must have a microchip in order to register with Pet Avenger.
                    If your pet does not have a microchip go to your
                    veterinarian and get one. If your pet gets stolen, you log
                    into your Pet Avenger account and check the "stolen" box in
                    your profile. That's it...that's all you have to do. Pet
                    Avenger does the rest.
                  </p>
                  <p className="mt-5">
                    <ul className="mt-4">
                      <li>
                        Pet Avenger will immediately alert law enforcement
                        agencies in the area, veterinarians, pet stores, news
                        outlets and community groups.
                      </li>
                      <li>
                        Your pet will instantaneously be categorized as "stolen"
                        on the Pet Avenger database and will alert anyone that
                        enters your pet's microchip number on the Pet Avenger
                        website to call law enforcement authorities to recover
                        your pet.{" "}
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
              <div className="col-lg-6 d-flex justify-content-lg-end justify-content-center">
                <div className="story-img">
                  <img
                    className="img-fluid"
                    src="/assets/images/bg/hero2-img.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default HowItsComponent;


